import React from 'react';
import { MDBContainer, MDBDataTable, MDBRow, MDBCol, MDBBtn, MDBSelect, MDBIcon, MDBCard, MDBCardBody } from 'mdbreact';
import DataLayer from '../Utilities/DataLayer';
import Header from './ComponentFragments/Header';
import Formatter from '../Utilities/Formatter';
import DashboardLineGraph from './ComponentFragments/DashboardLineGraph';

export default class TeamPerformance extends React.Component {

    constructor(props) {
        super(props);
        this.props.loaderOn();
        this.state = {
            teamData: [],
            yearData: [],
            fromWeekData: [],
            toWeekData: [],
            selectedYear: 0,
            selectedFromWeek: 0,
            selectedToWeek: 0,
            teamGraphData: {
                labels: [],
                currYTDSales: [],
                prevYTDSales: []
            },
            tableHidden: true
        }
        this.formatter = new Formatter();
        this.handleYearSelectChange = this.handleYearSelectChange.bind(this);
        this.handleFromSelectChange = this.handleFromSelectChange.bind(this);
        this.handleToSelectChange = this.handleToSelectChange.bind(this);
        this.getTeamPerformance = this.getTeamPerformance.bind(this);
    }

    async loadWeeksForYear(year) {
        this.props.loaderOn();
        var dl = new DataLayer();
        let result = await dl.Get('/common/getweeksforyear?yearId=' + year, 200);
        let fromWeeksData = [];
        let toWeeksData = [];
        result.data.forEach((week) => fromWeeksData.push({ checked: false, value: week.value, text: week.label }));
        result.data.forEach((week) => toWeeksData.push({ checked: false, value: week.value, text: week.label }));

        fromWeeksData[0].checked = true;
        toWeeksData[0].checked = true;
        this.setState({
            fromWeekData: fromWeeksData,
            toWeekData: toWeeksData,
            selectedFromWeek: fromWeeksData[0].value,
            selectedToWeek: toWeeksData[0].value
        })

        this.props.loaderOff();
    }

    handleYearSelectChange(selected) {
        this.setState({
            selectedYear: selected[0]
        });
        this.loadWeeksForYear(selected[0])
    }

    handleFromSelectChange(selected) {
        this.setState({
            selectedFromWeek: selected[0]
        });
    }

    handleToSelectChange(selected) {
        this.setState({
            selectedToWeek: selected[0]
        });
    }

    async componentWillMount() {
        this.props.loaderOn();
        var dl = new DataLayer();
        let result = await dl.Get('/common/getyears', 200);
        let yearsData = [];
        result.data[0].forEach((year) => yearsData.push({ checked: false, value: year.value, text: year.label }));
        yearsData[0].checked = true;

        let teamGraphData = {
            labels: [],
            currYTDSales: [],
            prevYTDSales: []
        }
        let graphResponse = await dl.Post('/common/GetGraphData', 1)

        graphResponse.data.forEach((entry) => {
            teamGraphData.labels.push(entry.month);
            teamGraphData.currYTDSales.push(entry.currYr);
            teamGraphData.prevYTDSales.push(entry.prevYr);
        })

        this.setState({
            yearData: yearsData,
            selectedYear: yearsData[0].value,
            teamGraphData: teamGraphData
        })
        this.props.loaderOff();
    }

    async getTeamPerformance() {
        this.props.loaderOn();
        var dl = new DataLayer();
        await dl.Get('/teamleader/GetTeamPerformance?fromWeek=' + this.state.selectedFromWeek + '&toWeek=' + this.state.selectedToWeek, 200).then((response) => {
            let demRecs = [];
            let rec;
            response.data.map((dem) => {
                rec = {
                    isSecondGen: dem.isManager ? dem.isSecondGen ? [<i key="cell1" className="far fa-thumbs-up mr-2 green-text" aria-hidden="true"></i>, dem.isSecondGen] : [<i key="cell1" className="far fa-times-circle mr-2 red-text" aria-hidden="true"></i>, dem.isSecondGen] : '',
                    certDem: dem.certDem ? [<MDBIcon className="green-text" far icon="check-circle" />, dem.certDem] : [<MDBIcon className="red-text" far icon="times-circle" />, dem.certDem],
                    unitName: dem.unitName,
                    managerName: dem.managerName,
                    sfCurrentCode: dem.sfCurrentCode,
                    demName: dem.demName,
                    recruitedByCode: dem.recruitedByCode,
                    recruitedBy: dem.recruitedBy,
                    demStatus: dem.demStatus,
                    sales: dem.isManager ? this.formatter.formatCurrency(dem.sales) : '',
                    personalSales: this.formatter.formatCurrency(dem.personalSales),
                    recruitCount: dem.recruitCount
                }
                demRecs.push(rec);
            });
            let tableData = {
                columns: [{
                    label: '2nd Gen',
                    field: 'isSecondGen',
                    sort: 'asc'
                },
                {
                    label: 'Certified',
                    field: 'certDem',
                    sort: 'asc'
                },
                {
                    label: 'Unit Name',
                    field: 'unitName',
                    sort: 'asc'
                },
                {
                    label: 'Manager Name',
                    field: 'managerName',
                    sort: 'asc'
                },
                {
                    label: 'Code',
                    field: 'sfCurrentCode',
                    sort: 'asc'
                },
                {
                    label: 'Dem Name',
                    field: 'demName',
                    sort: 'asc'
                },
                {
                    label: 'Recruited By Code',
                    field: 'recruitedByCode',
                    sort: 'asc'
                },
                {
                    label: 'Recruited By',
                    field: 'recruitedBy',
                    sort: 'asc'
                },
                {
                    label: 'Status',
                    field: 'demStatus',
                    sort: 'asc'
                },
                {
                    label: 'Unit Sales',
                    field: 'sales',
                    sort: 'asc'
                }, {
                    label: 'Personal Sales',
                    field: 'personalSales',
                    sort: 'asc'
                }, {
                    label: 'Recruits',
                    field: 'recruitCount',
                    sort: 'asc'
                }],
                rows: demRecs
            }
            this.setState({
                teamData: tableData,
                tableHidden: false
            });
            this.props.loaderOff();
        })

    }

    render() {

        return (
            <div>
                <Header headerText='Team Performance Report'
                    subHeaderText="(Click Go to load detailed report for selected weeks)"
                    hideSearch='true'
                />
                <MDBCard>
                    <MDBCardBody>
                <MDBRow>
                    <MDBCol md="6">
                        <MDBContainer>
                            <MDBRow className="mt-3">
                                <MDBCol>
                                    <MDBSelect label="Year..."
                                        options={this.state.yearData}
                                        selected="Filter"
                                        getValue={this.handleYearSelectChange}
                                        required
                                    />
                                </MDBCol>

                            </MDBRow>
                            <MDBRow className="mt-3">
                                <MDBCol>
                                    <MDBSelect label="From Week..."
                                        options={this.state.fromWeekData}
                                        selected="Filter"
                                        getValue={this.handleFromSelectChange}
                                        required
                                    />
                                </MDBCol>
                            </MDBRow>
                            <MDBRow className="mt-3">
                                <MDBCol>
                                    <MDBSelect label="To Week..."
                                        options={this.state.toWeekData}
                                        selected="Filter"
                                        getValue={this.handleToSelectChange}
                                        required
                                    />
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol>
                                    <MDBBtn onClick={this.getTeamPerformance}>Go</MDBBtn>
                                </MDBCol>
                            </MDBRow>
                        </MDBContainer>
                    </MDBCol>

                    <MDBCol md="6">
                        <MDBContainer>
                            <DashboardLineGraph chartName="Team Sales Performance" graphData={this.state.teamGraphData} />
                        </MDBContainer>
                    </MDBCol>
                </MDBRow>

                <br />

                <div hidden={this.state.tableHidden}>
                    <hr />
                    <MDBContainer>
                        <MDBRow>
                            <span style={{ fontWeight: "bold" }}>Detailed Team Results<br />Weeks {this.state.selectedFromWeek} to {this.state.selectedToWeek}</span>
                        </MDBRow>
                        
                    </MDBContainer>
                    <MDBDataTable
                        responsive
                        striped
                        bordered
                        hover
                        data={this.state.teamData}
                        paging={false}
                        autoWidth
                        />;

                        </div>
                    </MDBCardBody>
                    </MDBCard>
            </div>
        );
    }


}
